import { render } from "./Loading.vue?vue&type=template&id=52bf0839&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=52bf0839&scoped=true&lang=css"

import exportComponent from "/home/samuel/Dokumente/Webtheke/Projekte/zeiterfassungstool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bf0839"]])

export default __exports__